<form (ngSubmit)="submit()" class="message-modal">
  <h1 class="title" i18n="@@profile.changeEmail.title" id="modal-title">E-Mail-Adresse ändern</h1>
  <p class="body" i18n="@@profile.changeEmail.content">
        Hier können Sie die E-Mail-Adresse Ihres Profils ändern.
        Nach erfolgreicher Änderung werden Sie abgemeldet und Sie müssen sich mit der neuen E-Mail-Adresse erneut bei
        CléA anmelden.
    </p>
  <div class="form-group">
    <label class="label" for="profile-current-email" i18n="@@profile.changeEmail.formCurrentEmail">Aktuelle
            E-Mail</label>
    <input [value]="currentEmail" class="input" disabled="true" id="profile-current-email" type="email"/>
  </div>
  <div class="form-group">
    <label class="label" for="profile-email">
      <ng-container i18n="@@profile.changeEmail.formNewEmail">Neue E-Mail</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <input [formControl]="email" class="input" id="profile-email" type="email"/>
    @if (email.invalid && email.touched) {
      <div
        class="validation error" i18n="@@profile.changeEmail.formInvalidEmail">Bitte geben Sie eine gültige
            E-Mail-Adresse ein.
        </div>
    }
  </div>
  <div class="form-group">
    <label class="label" for="profile-confirm-email">
      <ng-container i18n="@@profile.changeEmail.formRepeatNewEmail">Neue E-Mail wiederholen</ng-container>
      <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
    </label>
    <input [formControl]="confirmEmail" class="input" id="profile-confirm-email" type="email"/>
    @if (form.hasError('unconfirmedEmail') && form.touched) {
      <div
        class="validation error" i18n="@@profile.changeEmail.formInvalidRepeatEmail">Bitte wiederholen Sie die
            E-Mail-Adresse.
        </div>
    }
  </div>
  <div class="action">
    @if ((isLoading$ | async) === false) {
      <button (click)="cancel()" class="button" i18n="@@profile.changeEmail.formBtnCancel" type="button">
                Abbrechen
            </button>
      <button class="button primary" i18n="@@profile.changeEmail.formBtnSave" type="submit">Ändern</button>
    }
    <app-spinner [visible]="isLoading$ | async"></app-spinner>
  </div>
</form>
